import { dirname, resolve } from "node:path";
export function resolveFilePath(...paths) {
    return resolve(...paths);
}
export function dirnameOfFilePath(filePath) {
    return dirname(filePath);
}
//# sourceMappingURL=path.js.map